import React from "react";

export const HeartIcon = ({
  strokeWidth = 3,
  size = "24",
  cursor = "pointer",
  color = "currentColor"
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.18256 4.76737C7.68809 3.02021 5.19595 2.55022 3.32348 4.15011C1.45101 5.74999 1.18739 8.42491 2.65785 10.3171C3.88044 11.8903 7.58043 15.2084 8.79309 16.2823C8.92876 16.4024 8.99659 16.4625 9.07572 16.4861C9.14478 16.5067 9.22034 16.5067 9.2894 16.4861C9.36853 16.4625 9.43637 16.4024 9.57204 16.2823C10.7847 15.2084 14.4847 11.8903 15.7073 10.3171C17.1777 8.42491 16.9463 5.73316 15.0416 4.15011C13.137 2.56705 10.677 3.02021 9.18256 4.76737Z"
        stroke="black"
        strokeWidth="1.34546"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
